import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTools,
  faBuilding,
  faIndustry
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import ModernHeroSection from '../components/sections/ModernHeroSection';
import './Home.css';

const Home = () => {
  const { t } = useTranslation();
  // Datos para slider (pueden ser reemplazados con datos reales)
  // const sliderData = [
  //   {
  //     id: 1,
  //     image: '../assets/images/hero-slide1.jpg',
  //     title: 'Servicios Electromecánicos Especializados',
  //     subtitle: 'Mantenimiento experto para la industria médica',
  //     cta: 'Solicitar Cotización'
  //   },
  //   {
  //     id: 2,
  //     image: '../assets/images/hero-slide2.jpg',
  //     title: 'Expertos en Equipamiento Médico',
  //     subtitle: 'Soluciones integrales para instalaciones hospitalarias',
  //     cta: 'Nuestros Servicios'
  //   },
  //   {
  //     id: 3,
  //     image: '../assets/images/hero-slide3.jpg',
  //     title: 'Mantenimiento Preventivo y Correctivo',
  //     subtitle: 'Aseguramos el funcionamiento óptimo de sus instalaciones',
  //     cta: 'Contáctenos'
  //   }
  // ];

  // Servicios
  const featuredServices = [
    {
      id: 1,
      icon: faBuilding,
      titleKey: 'home.services.featured.0.title',
      descriptionKey: 'home.services.featured.0.description',
      link: '/servicios'
    },
    {
      id: 2,
      icon: faTools,
      titleKey: 'home.services.featured.1.title',
      descriptionKey: 'home.services.featured.1.description',
      link: '/servicios'
    },
    {
      id: 3,
      icon: faIndustry,
      titleKey: 'home.services.featured.2.title',
      descriptionKey: 'home.services.featured.2.description',
      link: '/servicios'
    }
  ];

  return (
    <>
      {/* Hero Section con el nuevo componente moderno */}
      <ModernHeroSection imageSrc={process.env.PUBLIC_URL + '/images/services/Plant.png'} />

      {/* Diferenciadores Section - fusiona "Qué nos diferencia" + "Por qué elegir ProMedic" (issue #418 P1-5) */}
      <section className="section bg-light" id="diferencia">
        <Container>
          <div className="section-header text-center mb-5">
            <h2 className="section-title modern-title">{t('home.differentiators.title', '¿Por qué elegir ProMedic?')}</h2>
            <p className="section-subtitle">
              {t('home.differentiators.subtitle', 'Más de 16 años de experiencia en servicios electromecánicos y soluciones integrales para la industria de dispositivos médicos.')}
            </p>
          </div>

          <Row>
            <Col md={4} className="mb-4 mb-md-0">
              <div className="feature-box text-center">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={faIndustry} size="3x" className="text-primary" />
                </div>
                <h3 className="feature-title">{t('home.differentiators.feature1.title', 'Experiencia Especializada')}</h3>
                <p>
                  {t('home.differentiators.feature1.description', 'Contamos con más de 16 años de experiencia en servicios electromecánicos específicamente para instalaciones médicas. Nuestro equipo de técnicos e ingenieros está capacitado en las particularidades del equipamiento médico y sus requisitos especiales.')}
                </p>
              </div>
            </Col>
            <Col md={4} className="mb-4 mb-md-0">
              <div className="feature-box text-center">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={faTools} size="3x" className="text-primary" />
                </div>
                <h3 className="feature-title">{t('home.differentiators.feature2.title', 'Capital Humano Certificado')}</h3>
                <p>
                  {t('home.differentiators.feature2.description', 'Nuestro equipo está certificado y especializado en cumplimiento con los estándares más exigentes de las empresas del sector médico e industrial.')}
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className="feature-box text-center">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={faBuilding} size="3x" className="text-primary" />
                </div>
                <h3 className="feature-title">{t('home.differentiators.feature3.title', 'Soluciones Integrales de Valor')}</h3>
                <p>
                  {t('home.differentiators.feature3.description', 'Manejamos proyectos completos con nuestro propio personal especializado, optimizando recursos sin comprometer la calidad ni el cumplimiento normativo.')}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Servicios Section - Estilo Mejorado */}
      <section className="section modern-services-section" id="servicios">
        <Container>
          <h2 className="section-title modern-title text-center">{t('home.services.title', 'Nuestros Servicios')}</h2>
          
          <Row className="justify-content-center">
            {featuredServices.map((service) => (
              <Col lg={4} md={6} className="mb-4" key={service.id}>
                <div className="service-card modern-card">
                  <div className="service-icon modern-icon">
                    <FontAwesomeIcon icon={service.icon} />
                  </div>
                  <h3 className="service-title">{t(service.titleKey, service.id === 1 ? 'Proyectos' : service.id === 2 ? 'Pro Servicios' : 'Productos')}</h3>
                  <p>{t(service.descriptionKey, service.id === 1 ? 'Dirección y desarrollo de proyectos...' : service.id === 2 ? 'Mantenimiento general...' : 'Desarrollo de estaciones...')}</p>
                  <Link to={service.link} className="service-link modern-link">
                    {t('home.services.readMore', 'Leer más')}
                  </Link>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Proyectos Destacados Section - Estilo Mejorado */}
      {/*
      <section className="section bg-light" id="proyectos">
        <Container>
          <h2 className="section-title modern-title text-center">{t('home.projects.title', 'Proyectos Destacados')}</h2>
          
          <Row>
            {featuredProjects.map((project) => (
              <Col lg={4} md={6} className="mb-4" key={project.id}>
                <Card className="project-card modern-card">
                  <div className="project-img-container">
                    <div className="modern-project-placeholder">
                      <span className="project-number">0{project.id}</span>
                    </div>
                  </div>
                  <Card.Body>
                    <Card.Title className="project-title">{t(project.titleKey, `Project Title ${project.id}`)}</Card.Title>
                    <Card.Text>{t(project.descriptionKey, `Project description ${project.id}`)}</Card.Text>
                    <Link to={project.link} className="btn btn-outline-primary modern-outline-button">
                      {t('home.projects.seeDetails', 'Ver Detalles')}
                    </Link>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          
          <div className="text-center mt-5">
            <Link to="/proyectos">
              <Button variant="outline-primary" size="lg" className="modern-outline-button">{t('home.projects.exploreMore', 'Explorar más proyectos')}</Button>
            </Link>
          </div>
        </Container>
      </section>
      */}

      {/* Testimonios Section - Mantenemos el TestimonialSlider */}
      {/*
      <section className="section testimonials-section">
        <Container>
          <h2 className="section-title modern-title">{t('home.testimonials.title', 'Lo que dicen nuestros clientes')}</h2>
          <TestimonialSlider />
        </Container>
      </section>
      */}

      {/* Call to Action Section - Estilo Mejorado */}
      <section className="modern-cta">
        <Container className="py-5">
          <Row className="align-items-center justify-content-center text-center">
            <Col lg={8}>
              <h2 className="cta-title mb-4">{t('home.cta.title', '¿Necesitas soluciones para tus instalaciones industriales?')}</h2>
              <p className="cta-text mb-4">
                {t('home.cta.text', 'En ProMedic tenemos el más alto compromiso para brindar soluciones integrales para el mantenimiento y mejora de instalaciones industriales en Costa Rica. Nuestro equipo de expertos está listo para brindarte soluciones personalizadas.')}
              </p>
              <Link to="/contacto">
                <Button variant="primary" size="lg" className="modern-button">
                  {t('home.cta.button', 'Contáctanos Hoy')}
                </Button>
              </Link>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Home; 